/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S13_P1_PreInputs */

const tr_iade_iptal_s13_p1_pre = /** @type {(inputs: Iade_Iptal_S13_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Politika'dan doğan uyuşmazlıkların çözümünde`)
};

const en_iade_iptal_s13_p1_pre = /** @type {(inputs: Iade_Iptal_S13_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For the resolution of disputes arising from this Policy, the jurisdiction provisions in clause 20 of the`)
};

const de_iade_iptal_s13_p1_pre = /** @type {(inputs: Iade_Iptal_S13_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Beilegung von Streitigkeiten aus dieser Richtlinie gelten die Zuständigkeitsbestimmungen in Ziffer 20 des Dokuments`)
};

const ru_iade_iptal_s13_p1_pre = /** @type {(inputs: Iade_Iptal_S13_P1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При разрешении споров, возникающих из настоящей Политики, применяются положения о подсудности пункта 20 документа`)
};

/**
* | output |
* | --- |
* | "For the resolution of disputes arising from this Policy, the jurisdiction provisions in clause 20 of the" |
*
* @param {Iade_Iptal_S13_P1_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s13_p1_pre = /** @type {((inputs?: Iade_Iptal_S13_P1_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S13_P1_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s13_p1_pre(inputs)
	if (locale === "de") return de_iade_iptal_s13_p1_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s13_p1_pre(inputs)
	return tr_iade_iptal_s13_p1_pre(inputs)
});